import React, { useEffect, useState } from 'react';
import './SearchBar.css';

const SearchBar = ({
  onSearch,
  placeholder = 'Search...',
  value = '',
  showSearchState = true,
  resultCount = 0,
  isUpdating = false
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setSearchTerm(value || '');
  }, [value]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <div className="search-bar-container">
      <div className="search-bar">
        <svg 
          className="search-icon" 
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleChange}
        />
        {searchTerm && (
          <button
            type="button"
            className="search-clear"
            onClick={handleClear}
            title="Clear search"
            aria-label="Clear search"
          >
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
      </div>
      {showSearchState && searchTerm && (
        <div className="search-state">
          <div className="search-state-copy">
            <span className="search-state-label">Search Mode</span>
            <div className="search-state-text">
              Showing results for <span className="search-state-term">"{searchTerm}"</span>
            </div>
          </div>
          <div className="search-state-actions">
            <span className="search-state-count">
              {isUpdating ? 'Updating...' : `${resultCount} found`}
            </span>
            <button type="button" className="search-reset-button" onClick={handleClear}>
              Clear Search
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
